// extracted by mini-css-extract-plugin
export default {"melodyVideo":"vK-z","isFullWidth":"wK-z","landingPageVideo":"xK-z","play":"yK-z","iframeVideo":"zK-z","playHidden":"AK-z","fullwidth":"BK-z"};